export const SCHEDULED_JOURNEY_MAX_EXECUTIONS_PER_MINUTE = 1000;
export const SCHEDULED_JOURNEY_MAX_SEGMENT_SIZE = 50000;
